<template>
  <div v-if="loading">
    <pageLoader :msg='"Fetching the user data."'/>
 </div>
  <div class="select-vahicles" v-else>
    <section class="row justify-content-center" >
      <div class="col-12 col-md-10 col-lg-8 col-xl-8 col-xxl-8" >
        <h1 class="main-header">Insure and Secure Your Vehicle</h1>
        <p class="subheading">Protect your journey with motor insurance</p>
            <SelectCard />
      </div>
    </section>
  </div>
</template>

<script>
import SelectCard from "../selectCard/SelectCard.vue";
import pageLoader from "../pageLoaders/pageLoader.vue";

export default {
  name: "SelectVehicle",
  components: {
    SelectCard,
    pageLoader,
  },
  data() {
    return {
      loading: true,
      intervalId: null,
      timeoutId: null,
    }
  },
  mounted() {
    if (this.$store.state.configData) {
      this.loading = false;
    }
    sessionStorage.setItem('profileOpeningStatus', JSON.stringify(false));
    sessionStorage.removeItem('plansWithAddons');
    sessionStorage.removeItem('selectedUniqueAddons');
    sessionStorage.removeItem('user-type');
    sessionStorage.removeItem('userData');
    const token = sessionStorage.getItem("vuex") ? JSON.parse(sessionStorage.getItem("vuex"))?.token : null;
    const rmData = sessionStorage.getItem("rm_data") ? JSON.parse(sessionStorage.getItem("rm_data")) : null;

    if (token && !rmData) {
      this.getUserData(token);

      this.intervalId = setInterval(() => {
        const updatedRmData = sessionStorage.getItem("rm_data") ? JSON.parse(sessionStorage.getItem("rm_data")) : null;

        if (updatedRmData) {
          clearInterval(this.intervalId);
          clearTimeout(this.timeoutId);
          return;
        }

        this.getUserData(token);
      }, 10000);

      this.timeoutId = setTimeout(() => {
        clearInterval(this.intervalId);
      }, 300000); // stop after 5 minutes
    }
  },
  methods: {
    async getUserData(token) {
      const response = await this.backendApi("getRmDetails", [], { Authorization: `Bearer ${token}` }, "get");
      if (response.data.errors.length > 0) {
        return this.$router.push({
          path: "/error-page",
          query: { msg: response.data.errors[0]["errorMessage"] },
        });
      }

      this.rmData = response.data.data;
      sessionStorage.setItem("rm_data", JSON.stringify(this.rmData));
    }
  },
  beforeUnmount() {
    clearInterval(this.intervalId);
    clearTimeout(this.timeoutId);
  }
};
</script>
<style scoped lang="scss">
@import "../../assets/scss/components/select-vahicle.scss";
</style>
